import { Box, BoxProps } from "@chakra-ui/react";
import { msToDHMS } from "./time";
import { CountdownDigit } from "./CountdownDigit";

interface CountdownProps extends BoxProps {
  timeLeftMs: number;
}

export const Countdown = ({ timeLeftMs, ...props }: CountdownProps) => {
  const { d, h, m, s } = msToDHMS(timeLeftMs);
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      {...props}
    >
      {d ? (
        <>
          <CountdownDigit value={d} />
          <Box paddingLeft={2} fontWeight={"bold"}>
            day{d > 1 ? "s" : ""}
          </Box>
        </>
      ) : (
        <>
          {h ? <CountdownDigit showColon={true} value={h} /> : null}
          <CountdownDigit showColon={true} value={m} />
          <CountdownDigit value={s} />
        </>
      )}
    </Box>
  );
};
